{
    "neutral": {
        "prominent": {
            "static": {
                "background": "var(--hmf-fill-tertiary-static)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "hover": {
                "background": "var(--hmf-fill-tertiary-hover)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "active": {
                "background": "var(--hmf-fill-tertiary-active)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "disabled": {
                "background": "var(--hmf-fill-disabled)",
                "color": "var(--hmf-label-disabled)",
                "border": "none"
            }
        },
        "subtle": {
            "static": {
                "background": "var(--hmf-fill-secondary-subtle-static)",
                "color": "var(--hmf-label-base)",
                "border": "none"
            },
            "hover": {
                "background": "var(--hmf-fill-secondary-subtle-hover)",
                "color": "var(--hmf-label-base)",
                "border": "none"
            },
            "active": {
                "background": "var(--hmf-fill-secondary-subtle-active)",
                "color": "var(--hmf-label-base)",
                "border": "none"
            },
            "disabled": {
                "background": "var(--hmf-fill-disabled-subtle)",
                "color": "var(--hmf-label-disabled)",
                "border": "none"
            }
        },
        "outline": {
            "static": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-secondary-static)",
                "border": "1px solid var(--hmf-border-secondary-static)"
            },
            "hover": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-secondary-hover)",
                "border": "2px solid var(--hmf-border-secondary-hover)"
            },
            "active": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-secondary-active)",
                "border": "2px solid var(--hmf-border-secondary-active)"
            },
            "disabled": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-disabled)",
                "border": "1px solid var(--hmf-border-disabled-subtle)"
            }
        }
    },
    "positive": {
        "prominent": {
            "static": {
                "background": "var(--hmf-fill-positive-static)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "hover": {
                "background": "var(--hmf-fill-positive-hover)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "active": {
                "background": "var(--hmf-fill-positive-active)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "disabled": {
                "background": "var(--hmf-fill-disabled)",
                "color": "var(--hmf-label-disabled)",
                "border": "none"
            }
        },
        "subtle": {
            "static": {
                "background": "var(--hmf-fill-positive-subtle-static)",
                "color": "var(--hmf-label-positive)",
                "border": "none"
            },
            "hover": {
                "background": "var(--hmf-fill-positive-subtle-hover)",
                "color": "var(--hmf-label-positive-hover)",
                "border": "none"
            },
            "active": {
                "background": "var(--hmf-fill-positive-subtle-active)",
                "color": "var(--hmf-fill-positive-subtle-active)",
                "border": "none"
            },
            "disabled": {
                "background": "var(--hmf-fill-disabled-subtle)",
                "color": "var(--hmf-label-disabled)",
                "border": "none"
            }
        },
        "outline": {
            "static": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-positive)",
                "border": "1px solid var(--hmf-border-positive)"
            },
            "hover": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-positive-hover)",
                "border": "2px solid var(--hmf-border-positive)"
            },
            "active": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-positive-active)",
                "border": "2px solid var(--hmf-border-positive)"
            },
            "disabled": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-disabled)",
                "border": "1px solid var(--hmf-border-disabled-subtle)"
            }
        }
    },
    "warning": {
        "prominent": {
            "static": {
                "background": "var(--hmf-fill-warning-static)",
                "color": "var(--hmf-label-warning)",
                "border": "none"
            },
            "hover": {
                "background": "var(--hmf-fill-warning-hover)",
                "color": "var(--hmf-label-warning-hover)",
                "border": "none"
            },
            "active": {
                "background": "var(--hmf-fill-warning-active)",
                "color": "var(--hmf-label-warning-active)",
                "border": "none"
            },
            "disabled": {
                "background": "var(--hmf-fill-disabled)",
                "color": "var(--hmf-label-disabled)",
                "border": "none"
            }
        },
        "subtle": {
            "static": {
                "background": "var(--hmf-fill-warning-subtle-static)",
                "color": "var(--hmf-label-warning)",
                "border": "none"
            },
            "hover": {
                "background": "var(--hmf-fill-warning-subtle-hover)",
                "color": "var(--hmf-label-warning-hover)",
                "border": "none"
            },
            "active": {
                "background": "var(--hmf-fill-warning-subtle-active)",
                "color": "var(--hmf-label-warning-active)",
                "border": "none"
            },
            "disabled": {
                "background": "var(--hmf-fill-disabled-subtle)",
                "color": "var(--hmf-label-disabled)",
                "border": "none"
            }
        },
        "outline": {
            "static": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-warning)",
                "border": "1px solid var(--hmf-border-warning)"
            },
            "hover": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-warning-hover)",
                "border": "2px solid var(--hmf-border-warning)"
            },
            "active": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-warning-active)",
                "border": "2px solid var(--hmf-border-warning)"
            },
            "disabled": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-disabled)",
                "border": "1px solid var(--hmf-border-disabled-subtle)"
            }
        }
    },
    "negative": {
        "prominent": {
            "static": {
                "background": "var(--hmf-fill-negative-static)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "hover": {
                "background": "var(--hmf-fill-negative-hover)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "active": {
                "background": "var(--hmf-fill-negative-active)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "disabled": {
                "background": "var(--hmf-fill-disabled)",
                "color": "var(--hmf-label-disabled)",
                "border": "none"
            }
        },
        "subtle": {
            "static": {
                "background": "var(--hmf-fill-negative-subtle-static)",
                "color": "var(--hmf-label-negative)",
                "border": "none"
            },
            "hover": {
                "background": "var(--hmf-fill-negative-subtle-hover)",
                "color": "var(--hmf-label-negative-hover)",
                "border": "none"
            },
            "active": {
                "background": "var(--hmf-fill-negative-subtle-active)",
                "color": "var(--hmf-label-negative-active)",
                "border": "none"
            },
            "disabled": {
                "background": "var(--hmf-fill-disabled-subtle)",
                "color": "var(--hmf-label-disabled)",
                "border": "none"
            }
        },
        "outline": {
            "static": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-negative)",
                "border": "1px solid var(--hmf-border-negative)"
            },
            "hover": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-negative-hover)",
                "border": "2px solid var(--hmf-border-negative)"
            },
            "active": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-negative-active)",
                "border": "2px solid var(--hmf-border-negative)"
            },
            "disabled": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-disabled)",
                "border": "1px solid var(--hmf-border-disabled-subtle)"
            }
        }
    },
    "primary": {
        "prominent": {
            "static": {
                "background": "var(--hmf-fill-primary-static)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "hover": {
                "background": "var(--hmf-fill-primary-hover)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "active": {
                "background": "var(--hmf-fill-primary-active)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "disabled": {
                "background": "var(--hmf-fill-disabled)",
                "color": "var(--hmf-label-disabled)",
                "border": "none"
            }
        },
        "subtle": {
            "static": {
                "background": "var(--hmf-fill-primary-subtle-static)",
                "color": "var(--hmf-label-primary-static)",
                "border": "none"
            },
            "hover": {
                "background": "var(--hmf-fill-primary-subtle-hover)",
                "color": "var(--hmf-label-primary-hover)",
                "border": "none"
            },
            "active": {
                "background": "var(--hmf-fill-primary-subtle-active)",
                "color": "var(--hmf-label-primary-active)",
                "border": "none"
            },
            "disabled": {
                "background": "var(--hmf-fill-disabled-subtle)",
                "color": "var(--hmf-label-disabled)",
                "border": "none"
            }
        },
        "outline": {
            "static": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-primary-static)",
                "border": "1px solid var(--hmf-border-primary-static)"
            },
            "hover": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-primary-hover)",
                "border": "2px solid var(--hmf-border-primary-static)"
            },
            "active": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-primary-active)",
                "border": "2px solid var(--hmf-border-primary-static)"
            },
            "disabled": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-disabled)",
                "border": "1px solid var(--hmf-border-disabled-subtle)"
            }
        }
    },
    "secondary": {
        "prominent": {
            "static": {
                "background": "var(--hmf-fill-ext-secondary-static)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "hover": {
                "background": "var(--hmf-fill-ext-secondary-hover)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "active": {
                "background": "var(--hmf-fill-ext-secondary-active)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "disabled": {
                "background": "var(--hmf-fill-disabled)",
                "color": "var(--hmf-label-disabled)",
                "border": "none"
            }
        },
        "subtle": {
            "static": {
                "background": "var(--hmf-fill-ext-secondary-subtle-static)",
                "color": "var(--hmf-label-ext-secondary-static)",
                "border": "none"
            },
            "hover": {
                "background": "var(--hmf-fill-ext-secondary-subtle-hover)",
                "color": "var(--hmf-label-ext-secondary-hover)",
                "border": "none"
            },
            "active": {
                "background": "var(--hmf-fill-ext-secondary-subtle-active)",
                "color": "var(--hmf-label-ext-secondary-active)",
                "border": "none"
            },
            "disabled": {
                "background": "var(--hmf-fill-disabled-subtle)",
                "color": "var(--hmf-label-disabled)",
                "border": "none"
            }
        },
        "outline": {
            "static": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-ext-secondary-static)",
                "border": "1px solid var(--hmf-border-ext-secondary-static)"
            },
            "hover": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-ext-secondary-hover)",
                "border": "2px solid var(--hmf-border-ext-secondary-static)"
            },
            "active": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-ext-secondary-active)",
                "border": "2px solid var(--hmf-border-ext-secondary-static)"
            },
            "disabled": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-disabled)",
                "border": "1px solid var(--hmf-border-disabled-subtle)"
            }
        }
    },
    "tertiary": {
        "prominent": {
            "static": {
                "background": "var(--hmf-fill-ext-tertiarty-static)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "hover": {
                "background": "var(--hmf-fill-ext-tertiarty-hover)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "active": {
                "background": "var(--hmf-fill-ext-tertiarty-active)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "disabled": {
                "background": "var(--hmf-fill-disabled)",
                "color": "var(--hmf-label-disabled)",
                "border": "none"
            }
        },
        "subtle": {
            "static": {
                "background": "var(--hmf-fill-ext-tertiarty-subtle-static)",
                "color": "var(--hmf-label-ext-tertiary-static)",
                "border": "none"
            },
            "hover": {
                "background": "var(--hmf-fill-ext-tertiarty-subtle-hover)",
                "color": "var(--hmf-label-ext-tertiary-hover)",
                "border": "none"
            },
            "active": {
                "background": "var(--hmf-fill-ext-tertiarty-subtle-active)",
                "color": "var(--hmf-label-ext-tertiary-active)",
                "border": "none"
            },
            "disabled": {
                "background": "var(--hmf-fill-disabled-subtle)",
                "color": "var(--hmf-label-disabled)",
                "border": "none"
            }
        },
        "outline": {
            "static": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-ext-tertiary-static)",
                "border": "1px solid var(--hmf-border-ext-tertiary-static)"
            },
            "hover": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-ext-tertiary-hover)",
                "border": "2px solid var(--hmf-border-ext-tertiary-static)"
            },
            "active": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-ext-tertiary-active)",
                "border": "2px solid var(--hmf-border-ext-tertiary-static)"
            },
            "disabled": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-disabled)",
                "border": "1px solid var(--hmf-border-disabled-subtle)"
            }
        }
    },
    "accent": {
        "prominent": {
            "static": {
                "background": "var(--hmf-fill-ext-accent-static)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "hover": {
                "background": "var(--hmf-fill-ext-accent-hover)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "active": {
                "background": "var(--hmf-fill-ext-accent-active)",
                "color": "var(--hmf-label-inverse)",
                "border": "none"
            },
            "disabled": {
                "background": "var(--hmf-fill-disabled)",
                "color": "var(--hmf-label-disabled)",
                "border": "none"
            }
        },
        "subtle": {
            "static": {
                "background": "var(--hmf-fill-ext-accent-subtle-static)",
                "color": "var(--hmf-label-ext-accent-static)",
                "border": "none"
            },
            "hover": {
                "background": "var(--hmf-fill-ext-accent-subtle-hover)",
                "color": "var(--hmf-label-ext-accent-hover)",
                "border": "none"
            },
            "active": {
                "background": "var(--hmf-fill-ext-accent-subtle-active)",
                "color": "var(--hmf-label-ext-accent-active)",
                "border": "none"
            },
            "disabled": {
                "background": "var(--hmf-fill-disabled-subtle)",
                "color": "var(--hmf-label-disabled)",
                "border": "none"
            }
        },
        "outline": {
            "static": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-ext-accent-static)",
                "border": "1px solid var(--hmf-border-ext-accent-static)"
            },
            "hover": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-ext-accent-hover)",
                "border": "2px solid var(--hmf-border-ext-accent-static)"
            },
            "active": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-ext-accent-active)",
                "border": "2px solid var(--hmf-border-ext-accent-static)"
            },
            "disabled": {
                "background": "var(--hmf-fill-base)",
                "color": "var(--hmf-label-disabled)",
                "border": "1px solid var(--hmf-border-disabled-subtle)"
            }
        }
    }
}
